import { takeLatest, all, call, put } from "redux-saga/effects";
import {
  startInterfaceApiList,
  startAddNewInteraceApi,
  setInterfaceApiListData,
  completedFetch,
  completedNewAdd,
  startAppDocInteraceApiList,
  setInterfaceAppDocList,
  startRepoDocInteraceApiList,
  setInterfaceRepoDocList,
  setInterfaceFilterApiListData,
  startInterfaceFilterApiList,
  startDeleteInterfaceApiList,
  startStatusNewInteraceApi,
} from "./interfaceApi.slice.selector";
//notification
import { setNotificationAction } from "../NotificationStore/notification.slice.selector";
import {
  getAllInterfaces,
  addNewInterface,
  getInterfaceDocumentFolders,
  getInterfaceRepoFolder,
  addNewInterfaceFilter,
  getDeleteAllInterfaces,
  getStatusAllInterfaces,
} from "../../../Apis/Interface/Interface";

//(1) Watcher
function* startFetchInterfaceApiList() {
  yield takeLatest(startInterfaceApiList.type, setInterfaceList);
}
//(1) Next
function* setInterfaceList({ payload }) {
  try {
    const response_data = yield call(getAllInterfaces, payload);
    yield put(
      setInterfaceApiListData({ list: response_data, totalCount: 100 })
    );
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(1.5) Watcher
function* startFetchInterfaceFilterApiList() {
  yield takeLatest(startInterfaceFilterApiList.type, setInterfaceFilterList);
}
//(1.5) Next
function* setInterfaceFilterList({ payload }) {
  try {
    const response_data = yield call(addNewInterfaceFilter, payload);
    yield put(
      setInterfaceFilterApiListData({ list: response_data, totalCount: 100 })
    );
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(2) Watcher
function* startAddNewInterfaceApiWatcher() {
  yield takeLatest(startAddNewInteraceApi.type, callForAddNewInterface);
}
//(2)Next
function* callForAddNewInterface({ payload }) {
  try {
    const { data, tableData } = payload;
    yield call(addNewInterface, data);
    yield put(completedNewAdd());
    yield put(
      setNotificationAction({
        message: "New Folder Added Successfully",
        variant: "success",
      })
    );
    yield put(startInterfaceApiList(tableData));
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedNewAdd());
  }
}

//(3) Watcher
function* startFetchInterfaceAppFolderList() {
  yield takeLatest(startAppDocInteraceApiList.type, setAppFolderList);
}
//(3) Next
function* setAppFolderList({ payload }) {
  try {
    const response_data = yield call(getInterfaceDocumentFolders, payload);
    yield put(setInterfaceAppDocList(response_data));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(4) Watcher
function* startFetchInterfaceRepoFolderList() {
  yield takeLatest(startRepoDocInteraceApiList.type, setRepoFolderList);
}
//(4) Next
function* setRepoFolderList({ payload }) {
  try {
    const response_data = yield call(getInterfaceRepoFolder, payload);
    yield put(setInterfaceRepoDocList(response_data));
    yield put(completedFetch());
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(5) Watcher
function* startDeleteInterfaceApiListData() {
  yield takeLatest(startDeleteInterfaceApiList.type, setDeleteInterfaceList);
}
//(5) Next
function* setDeleteInterfaceList({ payload }) {
  try {
    const response_data = yield call(getDeleteAllInterfaces, payload);
    yield put(completedFetch());
    yield put(startInterfaceApiList({
      pageIndex: 0,
      pageSize: 10,
    }));
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

//(5) Watcher
function* startStatusInterfaceApiListData() {
  yield takeLatest(startStatusNewInteraceApi.type, setStatusInterfaceList);
}
//(5) Next
function* setStatusInterfaceList({ payload }) {
  try {
    const response_data = yield call(getStatusAllInterfaces, payload);
    yield put(completedFetch());
    yield put(startInterfaceApiList({
      pageIndex: 0,
      pageSize: 10,
    }));
  } catch (error) {
    yield put(
      setNotificationAction({
        message: error.message,
        variant: "error",
      })
    );
    yield put(completedFetch());
  }
}

///Accumulator
export default function* interfaceSaga() {
  yield all([
    call(startFetchInterfaceApiList),
    call(startFetchInterfaceFilterApiList),
    call(startFetchInterfaceAppFolderList),
    call(startFetchInterfaceRepoFolderList),
    call(startAddNewInterfaceApiWatcher),
    call(startDeleteInterfaceApiListData),
    call(startStatusInterfaceApiListData),
  ]);
}
